// questions.js
const questions = {
  English:   [
    'Microsoft Teams Video room'   ,
    'IT Service Desk'   ,
    'Office network connectivity'   ,
    'Digital collaboration'   ,
    'Mobile telephony service'   ,
    'Philips IT cloud orchestration' ,
    'Philips Personal Computer systems',
    'Windchill application'   ,
    'Planisware'   ,
    'Conga (Apttus) CPQ CLM'   ,
    'Salesforce cCRM'   ,
    'Health care - MP1 - Commercial'   ,
    'Health care imaging and ultrasound'   ,
    'IT Portal'   ,
    'TrackWise'   ,
    'ServiceMax'   ,
    'Philips voice cloud'   ,
    'Philips asset library' ,
    'Philips product library' ,
    'IT Experience Center' ,
    'Azure DevOps'   ,
    'GitHub'   ,
    'Artifactory'   ,
    'SonarQube'   ,
    'CodeScene'   ,
    'Coverity'   ,
    'Other Applications'   ,
],
  Spanish: [
    'Microsoft Teams Video room'   ,
    'IT Service Desk'   ,
    'Office network connectivity'   ,
    'Digital collaboration'   ,
    'Mobile telephony service'   ,
    'Philips IT cloud orchestration' ,
    'Philips Personal Computer systems',
    'IT Experience Center',
    'Windchill application'   ,
    'Planisware'   ,
    'Conga (Apttus) CPQ CLM'   ,
    'Salesforce cCRM'   ,
    'Health care - MP1 - Commercial'   ,
    'Health care imaging and ultrasound'   ,
    'IT Portal'   ,
    'TrackWise'   ,
    'ServiceMax'   ,
    'Philips voice cloud'   ,
    'Philips asset library' ,
    'Philips product library'  ,
    'Azure DevOps'   ,
    'GitHub'   ,
    'Artifactory'   ,
    'SonarQube'   ,
    'CodeScene'   ,
    'Coverity'   ,
    'Otra Aplicación'   ,
  ],
  French: [
    'Microsoft Teams Video room'   ,
    'IT Service Desk'   ,
    'Office network connectivity'   ,
    'Digital collaboration'   ,
    'Mobile telephony service'   ,
    'Philips IT cloud orchestration' ,
    'Philips Personal Computer systems',
    'IT Experience Center',
    'Windchill application'   ,
    'Planisware'   ,
    'Conga (Apttus) CPQ CLM'   ,
    'Salesforce cCRM'   ,
    'Health care - MP1 - Commercial'   ,
    'Health care imaging and ultrasound'   ,
    'IT Portal'   ,
    'TrackWise'   ,
    'ServiceMax'   ,
    'Philips voice cloud'   ,
    'Philips asset library' ,
    'Philips product library',
    'Azure DevOps'   ,
    'GitHub'   ,
    'Artifactory'   ,
    'SonarQube'   ,
    'CodeScene'   ,
    'Coverity'   ,
    'Autre Application'   ,
  ],
  German: [
    'Microsoft Teams Video room'   ,
    'IT Service Desk'   ,
    'Office network connectivity'   ,
    'Digital collaboration'   ,
    'Mobile telephony service'   ,
    'Philips IT cloud orchestration' ,
    'Philips Personal Computer systems',
    'IT Experience Center',
    'Windchill application'   ,
    'Planisware'   ,
    'Conga (Apttus) CPQ CLM'   ,
    'Salesforce cCRM'   ,
    'Health care - MP1 - Commercial'   ,
    'Health care imaging and ultrasound'   ,
    'IT Portal'   ,
    'TrackWise'   ,
    'ServiceMax'   ,
    'Philips voice cloud'   ,
    'Philips asset library' ,
    'Philips product library'  ,
    'Azure DevOps'   ,
    'GitHub'   ,
    'Artifactory'   ,
    'SonarQube'   ,
    'CodeScene'   ,
    'Coverity'   ,
    'Weitere Anwendungen'   ,
  ],
  Chinese: [
    'Microsoft Teams Video room'   ,
    'IT Service Desk'   ,
    'Office network connectivity'   ,
    'Digital collaboration'   ,
    'Mobile telephony service'   ,
    'Philips IT cloud orchestration' ,
    'Philips Personal Computer systems',
    'IT Experience Center',
    'Windchill application'   ,
    'Planisware'   ,
    'Conga (Apttus) CPQ CLM'   ,
    'Salesforce cCRM'   ,
    'Health care - MP1 - Commercial'   ,
    'Health care imaging and ultrasound'   ,
    'IT Portal'   ,
    'TrackWise'   ,
    'ServiceMax'   ,
    'Philips voice cloud'   ,
    'Philips asset library' ,
    'Philips product library'  ,
    'Azure DevOps'   ,
    'GitHub'   ,
    'Artifactory'   ,
    'SonarQube'   ,
    'CodeScene'   ,
    'Coverity'   ,
    '其他应用程序'   ,
  ],
  Japanese:[
    'Microsoft Teamsビデオルーム'   ,
    'IT Service Desk'   ,
    'Office network connectivity'   ,
    'Digital collaboration'   ,
    'Mobile telephony service'   ,
    'Philips IT cloud orchestration' ,
    'Philips Personal Computer systems',
    'IT Experience Center',
    'Windchill application'   ,
    'Planisware'   ,
    'Conga (Apttus) CPQ CLM'   ,
    'Salesforce cCRM'   ,
    'Health care - MP1 - Commercial'   ,
    'Health care imaging and ultrasound'   ,
    'IT Portal'   ,
    'TrackWise'   ,
    'ServiceMax'   ,
    'Philips voice cloud'   ,
    'Philips asset library' ,
    'Philips product library'  ,
    'Azure DevOps'   ,
    'GitHub'   ,
    'Artifactory'   ,
    'SonarQube'   ,
    'CodeScene'   ,
    'Coverity'   ,
    'その他のアプリケーション'   ,
  ],
  Dutch:[
    'Microsoft Teams Video room'   ,
    'IT Service Desk'   ,
    'Office network connectivity'   ,
    'Digital collaboration'   ,
    'Mobile telephony service'   ,
    'Philips IT cloud orchestration' ,
    'Philips Personal Computer systems',
    'IT Experience Center',
    'Windchill application'   ,
    'Planisware'   ,
    'Conga (Apttus) CPQ CLM'   ,
    'Salesforce cCRM'   ,
    'Health care - MP1 - Commercial'   ,
    'Health care imaging and ultrasound'   ,
    'IT Portal'   ,
    'TrackWise'   ,
    'ServiceMax'   ,
    'Philips voice cloud'   ,
    'Philips asset library' ,
    'Philips product library' ,
    'Azure DevOps'   ,
    'GitHub'   ,
    'Artifactory'   ,
    'SonarQube'   ,
    'CodeScene'   ,
    'Coverity'   ,
    'Andere Applicatie'   ,
  ]
};

export default questions;
